<template>
  <div class="app" v-title data-title="联系我们-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="5" />
    <div class="lianxi-cont rel">
      <div class="lianxi-main w1200 auto df align_center justify_end">
        <div class="yj-banner-tit lx-banner-tit df align_center flex_column justify_center ts fw abs">
          <div class="f50 ls1 b">团队预定</div>
          <div class="f17 ls3">Group Booking</div>
        </div>
        <div class="lianxi-main-text lh20 rel" v-if="data && data.Items && data.Items.length > 0">
          <div class="f16 fw tj cell_bk" v-if="data.Items[0].ContentText" v-html="data.Items[0].ContentText">
          </div>
          <div class="rel lianxi-main-site" v-if="data.Items[0].ThirdLink">
            <div class="df align_center f18 fw mt10 fa_wh tc ">
              <div v-if="data.Items[0].ThirdLink.Path" class="show-hand">
                <a :href="data.Items[0].ThirdLink.Path" target="_blank">购票介绍信下载</a>
              </div>
            </div>
          </div>
          <div class="lx-icon">
            <img src="@/assets/images/lx-icon1.png" class="db" alt="">
          </div>
        </div>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-lxwm-tdqyhz',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
  },
}
</script>
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/lianxi/lianxi-team.vue